export const isLayersTenant = () => {
  const url = window.location.hostname;
  return url.includes('layers');
};
